import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { postMerchant } from "../actions/merchantAction";
import PlacesAutocomplete, {
  geocodeByAddress,
} from "react-places-autocomplete";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Alert from "react-bootstrap/Alert";
import PhoneInput from "react-phone-input-2";
import { open_hours, close_hours } from "./files";
class CreateMerchantProfile extends React.Component {
  state = {
    errors: [],
    merchantName: "",
    postal_code: "",
    city: "",
    province: "",
    country: "Canada",
    lat: 0,
    long: 0,
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    website: "",
    address: "",
    store_hours: {
      1: {
        Open: "",
        Close: "",
      },
      2: {
        Open: "",
        Close: "",
      },
      3: {
        Open: "",
        Close: "",
      },
      4: {
        Open: "",
        Close: "",
      },
      5: {
        Open: "",
        Close: "",
      },
      6: {
        Open: "",
        Close: "",
      },
      0: {
        Open: "",
        Close: "",
      },
    },
    pricepoint: "",
    parent_organization: "",
    zone: "",
    vertical: "",
    free_shipping_threshold: 15000,
    shipping_cost_if_not_free: 1300,
    delivery_title: "",
    delivery_description: "",
    merchant_price: 1100,
    advanced_plan: false,
    text_alerts_on: false,
    text_alerts_phone_number: "",
    inzone_order_alert: false,
    delivery_alerts: false,
    delivery_alert_email: "",
    inzone_order_alert_email1: "",
    inzone_order_alert_email2: "",
    delivery_booked_alert: "",
    delivery_booked_email: "",
    pick_up_notes: "",
    weight_threshold: 9072,
    overweight_order_price: 2000,
    additional_standard_item_price: 300,
    additional_overweight_item_price: 500,
    shopify_store: false,
    payment_terms: "Net 15",
    payment_days: 15,
    default_security: 1,
    billing_contact: "",
    billing_email: "",
    allowed_fsas:
      "M4J,M5J,M6J,M4K,M5K,M6K,M4L,M5L,M4M,M6M,M5N,M6N,M4P,M5P,M6S,M6P,M4R,M5R,M4T,M6R,M4S,M5S,M5W,M5T,M4V,M5V,M4W,M4X,M5X,M8X,M4Y,M7Y,M8Y,M4C,M4B,M4N,M2P,M5A,M7A,M5B,M6B,M3C,M5C,M6C,M5E,M6E,M4G,M5G,M6G,M4H,M5H,M6H,M2L,M3B,M5M",
  };
  handleInputChange = this.handleInputChange.bind(this);
  handleSubmit = this.handleSubmit.bind(this);
  updateHours = this.updateHours.bind(this);

  componentDidMount() {
    this.props;
    this.props.location.search &&
      this.setState({ website: this.props.location.search.substring(1) });
  }
  displayErrors = (errors) =>
    errors.map((error, i) => <p key={i}>{error.message}</p>);

  isFormValid = () => {
    let errors = [];
    let error;

    if (this.isFormEmpty(this.state)) {
      error = { message: "Fill in all required fields" };
      this.setState({ errors: errors.concat(error) });
      return false;
    } else if (!this.isPhoneValid(this.state)) {
      error = { message: "Phone number is invalid" };
      this.setState({ errors: errors.concat(error) });
      return false;
    } else if (!this.isWebsiteValid(this.state)) {
      error = { message: "Website address should contain '.'" };
      this.setState({ errors: errors.concat(error) });
      return false;
    } else if (!this.isEmailValid(this.state)) {
      error = { message: "Email address should contain '@'" };
      this.setState({ errors: errors.concat(error) });
      return false;
    } else if (this.isStoreHoursValid(this.state)) {
      error = { message: "Please fill in store hours for all 7 weekdays" };
      this.setState({ errors: errors.concat(error) });
      return false;
    } else {
      return true;
    }
  };
  isFormEmpty = ({ merchantName, contact_email, website, contact_name }) => {
    return (
      !merchantName.length ||
      !contact_email.length ||
      !website.length ||
      !contact_name.length
    );
  };
  isPhoneValid = ({ contact_phone }) => {
    if (contact_phone.length == 11) {
      return true;
    } else {
      return false;
    }
  };
  isWebsiteValid = ({ website }) => {
    if (website.includes(".")) {
      return true;
    } else {
      return false;
    }
  };
  isEmailValid = ({ contact_email }) => {
    if (contact_email.includes("@")) {
      return true;
    } else {
      return false;
    }
  };
  isStoreHoursValid = ({ store_hours }) => {
    let length = [];
    Object.keys(store_hours).map((i) => {
      length.push(store_hours[i]["Open"].length);
      length.push(store_hours[i]["Close"].length);
    });
    return length.some((element) => element == 0);
  };

  handleSubmit(e) {
    e.preventDefault();
    if (this.isFormValid(this.state)) {
      const formData = new FormData();
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      formData.append("merchant[name]", this.state.merchantName);
      formData.append("merchant[website]", this.state.website);
      this.state.pricepoint &&
        formData.append("merchant[pricepoint]", this.state.pricepoint);
      this.state.parent_organization &&
        formData.append(
          "merchant[parent_organization]",
          this.state.parent_organization
        );
      this.state.zone && formData.append("merchant[zone]", this.state.zone);
      this.state.vertical &&
        formData.append("merchant[vertical]", this.state.vertical);
      formData.append("merchant[address]", this.state.address);
      formData.append("merchant[city]", this.state.city);
      formData.append("merchant[province]", this.state.province);
      formData.append("merchant[country]", this.state.country);
      formData.append("merchant[lat]", this.state.lat);
      formData.append("merchant[long]", this.state.long);
      formData.append("merchant[postal_code]", this.state.postal_code);
      formData.append("merchant[contact_name]", this.state.contact_name);
      formData.append("merchant[contact_email]", this.state.contact_email);
      formData.append(
        "merchant[contact_phone]",
        this.state.contact_phone.slice(1)
      );
      this.state.text_alerts_on &&
        formData.append("merchant[text_alerts_on]", this.state.text_alerts_on);
      this.state.text_alerts_phone_number &&
        formData.append(
          "merchant[text_alerts_phone_number]",
          this.state.text_alerts_phone_number
        );
      formData.append(
        "merchant[store_hours[1][Open]]",
        this.state.store_hours[1].Open
      );
      formData.append(
        "merchant[store_hours[1][Close]]",
        this.state.store_hours[1].Close
      );
      formData.append(
        "merchant[store_hours[2][Open]]",
        this.state.store_hours[2].Open
      );
      formData.append(
        "merchant[store_hours[2][Close]]",
        this.state.store_hours[2].Close
      );
      formData.append(
        "merchant[store_hours[3][Open]]",
        this.state.store_hours[3].Open
      );
      formData.append(
        "merchant[store_hours[3][Close]]",
        this.state.store_hours[3].Close
      );
      formData.append(
        "merchant[store_hours[4][Open]]",
        this.state.store_hours[4].Open
      );
      formData.append(
        "merchant[store_hours[4][Close]]",
        this.state.store_hours[4].Close
      );
      formData.append(
        "merchant[store_hours[5][Open]]",
        this.state.store_hours[5].Open
      );
      formData.append(
        "merchant[store_hours[5][Close]]",
        this.state.store_hours[5].Close
      );
      formData.append(
        "merchant[store_hours[6][Open]]",
        this.state.store_hours[6].Open
      );
      formData.append(
        "merchant[store_hours[6][Close]]",
        this.state.store_hours[6].Close
      );
      formData.append(
        "merchant[store_hours[0][Open]]",
        this.state.store_hours[0].Open
      );
      formData.append(
        "merchant[store_hours[0][Close]]",
        this.state.store_hours[0].Close
      );
      formData.append(
        "merchant[additional_standard_item_price]",
        this.state.additional_standard_item_price
      );
      formData.append("merchant[merchant_price]", this.state.merchant_price);
      formData.append("merchant[exchange_price]", this.state.merchant_price);
      formData.append(
        "merchant[additional_overweight_item_price]",
        this.state.additional_overweight_item_price
      );
      this.state.text_alerts_phone_number &&
        formData.append(
          "merchant[text_alerts_phone_number]",
          this.state.text_alerts_phone_number
        );
      this.state.inzone_order_alert &&
        formData.append(
          "merchant[inzone_order_alert]",
          this.state.inzone_order_alert
        );
      this.state.delivery_alerts &&
        formData.append(
          "merchant[delivery_alerts]",
          this.state.delivery_alerts
        );
      this.state.delivery_alert_email &&
        formData.append(
          "merchant[delivery_alert_email]",
          this.state.delivery_alert_email
        );
      this.state.inzone_order_alert_email1 &&
        formData.append(
          "merchant[inzone_order_alert_email1]",
          this.state.inzone_order_alert_email1
        );
      this.state.inzone_order_alert_email2 &&
        formData.append(
          "merchant[inzone_order_alert_email2]",
          this.state.inzone_order_alert_email2
        );
      this.state.delivery_booked_alert &&
        formData.append(
          "merchant[delivery_booked_alert]",
          this.state.delivery_booked_alert
        );
      this.state.delivery_booked_email &&
        formData.append(
          "merchant[delivery_booked_email]",
          this.state.delivery_booked_email
        );
      formData.append(
        "merchant[weight_threshold]",
        this.state.weight_threshold
      );
      formData.append(
        "merchant[free_shipping_threshold]",
        this.state.free_shipping_threshold
      );
      formData.append(
        "merchant[shipping_cost_if_not_free]",
        this.state.shipping_cost_if_not_free
      );
      formData.append(
        "merchant[overweight_order_price]",
        this.state.overweight_order_price
      );
      this.state.pick_up_notes &&
        formData.append("merchant[pick_up_notes]", this.state.pick_up_notes);
      this.state.delivery_title &&
        formData.append("merchant[delivery_title]", this.state.delivery_title);
      this.state.delivery_description &&
        formData.append(
          "merchant[delivery_description]",
          this.state.delivery_description
        );
      this.state.shopify_store &&
        formData.append("merchant[shopify_store]", this.state.shopify_store);
      this.state.advanced_plan &&
        formData.append("merchant[advanced_plan]", this.state.advanced_plan);
      formData.append("merchant[payment_terms]", this.state.payment_terms);
      formData.append("merchant[payment_days]", this.state.payment_days);
      formData.append(
        "merchant[default_security]",
        this.state.default_security
      );
      formData.append(
        "merchant[billing_contact]",
        this.state.billing_contact
          ? this.state.billing_contact
          : this.state.contact_name
      );
      formData.append(
        "merchant[billing_email]",
        this.state.billing_email
          ? this.state.billing_email
          : this.state.contact_email
      );
      this.state.allowed_fsas &&
        formData.append(
          "merchant[allowed_fsas]",
          "," + this.state.allowed_fsas + ","
        );
      this.props.postMerchant(formData, config);
    }
    // .then(response => this.doFulfillment(response))
    // .catch(error => console.log("api errors:", error));
    // .then(response => {
    //   console.log(JSON.stringify(response.data));
    // });
  }
  // redirect = () => {
  //   this.props.history.push({ pathname: "/trackers" });
  // };
  // handleCheckSubmit(event) {
  //   event.preventDefault();
  //   const value = this.state.fsa;
  //   this.toggleVisible();
  //   this.showAlert(value.slice(0, 3).toUpperCase());
  // }
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  updateHours(inputName) {
    return (event) => {
      event.preventDefault();
      const newValue = event.target.value;
      const name = event.target.name;

      this.setState((prevState) => {
        return {
          store_hours: {
            ...prevState.store_hours,
            [inputName]: {
              ...prevState.store_hours[inputName],
              [name]: newValue,
            },
          },
        };
      });

      if (newValue == 24) {
        this.setState((prevState) => {
          return {
            store_hours: {
              ...prevState.store_hours,
              [inputName]: {
                ...prevState.store_hours[inputName],
                Close: 0,
              },
            },
          };
        });
      }
    };
  }
  createOpenOptions = () =>
    open_hours.map((hour, i) => (
      <option key={i} value={i + 8}>
        {open_hours[i]}
      </option>
    ));
  createCloseOptions = () =>
    close_hours.map((hour, i) => (
      <option key={i} value={i + 15}>
        {close_hours[i]}
      </option>
    ));
  handleAddressChange = (address) => {
    const split = address.split(", ");
    this.setState({ address: split[0], city: split[1], province: split[2] });
  };
  handleSelect = (selected) => {
    geocodeByAddress(selected)
      .then((results) => this.handleResultsState(results))
      .catch((error) => console.error("Error", error));
  };
  handleResultsState = (results) => {
    // console.log(results);

    const split = results[0].formatted_address.split(", ");

    this.setState({
      address: split[0],
      city: results[0].address_components[3].long_name,
      province: results[0].address_components[5].long_name,
      postal_code: results[0].address_components[7].long_name,
      lat: results[0].geometry.location.lat(),
      long: results[0].geometry.location.lng(),
    });
  };
  render() {
    const { isLoggedIn } = this.props.user;

    const week = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    return (
      <div className={isLoggedIn ? "container-fluid" : "container"}>
        <style type="text/css">
          {`
    .btn-flat {
      display: inline;
      background-color: #184667;
      color: white;
      margin-bottom: 10px;
      width: 100%;
    }
    .bg-flat {
      background-color: #84cac14a;
      color: #047688;
      border-radius: 8px;
      border: 1px solid teal;  
    }
    .card-deck .card  {
      margin-bottom: 10px;  
      font-size: 1.2rem;
      display: flex;
    }
    .btn-xxl {
      padding: 10px;
      font-size: 1.2rem;
    }
    `}
        </style>
        <h3 className="text-center font-weight-bold text-dark">
          Create new Mile1 merchant account
        </h3>
        {console.log(this.props.location.search)}
        <br></br>
        <Form
          noValidate
          className="bg-flat container"
          onSubmit={this.handleSubmit}
        >
          <Form.Row>
            <Form.Group as={Col} controlId="formGridMerchant">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                placeholder="required"
                name="merchantName"
                onChange={this.handleInputChange}
              />
            </Form.Group>
            {!this.props.location.search && (
              <Form.Group as={Col} controlId="formGridWebsite">
                <Form.Label>Company Website</Form.Label>
                <Form.Control
                  placeholder="required"
                  name="website"
                  onChange={this.handleInputChange}
                />
              </Form.Group>
            )}
            {isLoggedIn && (
              <Col sm="2">
                <Form.Group>
                  <Form.Label>Shopify E-commerce?</Form.Label>
                  <Form.Check
                    name="shopify_store"
                    onChange={this.handleInputChange}
                  />
                </Form.Group>
              </Col>
            )}
            {isLoggedIn && (
              <Col sm="2">
                <Form.Group>
                  <Form.Label>Shopify Advanced Plan?</Form.Label>
                  <Form.Check
                    name="advanced_plan"
                    onChange={this.handleInputChange}
                  />
                </Form.Group>
              </Col>
            )}
          </Form.Row>
          {isLoggedIn && (
            <Form.Row>
              <Form.Group as={Col} controlId="formGridPricepoint">
                <Form.Label>PricePoint</Form.Label>
                <Form.Control
                  name="pricepoint"
                  onChange={this.handleInputChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridParent">
                <Form.Label>Parent Organization</Form.Label>
                <Form.Control
                  name="parent_organization"
                  onChange={this.handleInputChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridZone">
                <Form.Label>Zone</Form.Label>
                <Form.Control name="zone" onChange={this.handleInputChange} />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridVertical">
                <Form.Label>Vertical</Form.Label>
                <Form.Control
                  name="vertical"
                  onChange={this.handleInputChange}
                />
              </Form.Group>
            </Form.Row>
          )}
          <Form.Row>
            <Form.Group as={Col} controlId="formGridContactName">
              <Form.Label>Contact Name</Form.Label>
              <Form.Control
                placeholder="required"
                name="contact_name"
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formBasicEmail">
              <Form.Label>Contact Email</Form.Label>
              <Form.Control
                placeholder="required"
                type="email"
                name="contact_email"
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridPhone">
              <Form.Label>Contact Phone</Form.Label>
              <PhoneInput
                country={"ca"}
                countryCodeEditable={false}
                specialLabel={""}
                value={this.state.contact_phone}
                onChange={(contact_phone) => this.setState({ contact_phone })}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridAddress">
              <Form.Label>Address</Form.Label>
              <PlacesAutocomplete
                value={this.state.address}
                onChange={this.handleAddressChange}
                onSelect={this.handleSelect}
                searchOptions={{
                  location: new google.maps.LatLng(43.65107, -79.347015),
                  radius: 2000,
                  types: ["address"],
                }}
              >
                {({
                  getInputProps,
                  suggestions,
                  getSuggestionItemProps,
                  loading,
                }) => (
                  <div>
                    <Form.Control
                      placeholder="required"
                      {...getInputProps({
                        placeholder: "Start typing the address",
                      })}
                    />
                    <div className="autocomplete-dropdown-container">
                      {loading && <div>Loading...</div>}
                      {suggestions.map((suggestion) => {
                        const className = suggestion.active
                          ? "suggestion-item--active"
                          : "suggestion-item";
                        // inline style for demonstration purpose
                        const style = suggestion.active
                          ? {
                              backgroundColor: "lightblue",
                              cursor: "pointer",
                            }
                          : { backgroundColor: "#ffffff", cursor: "pointer" };
                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className,
                              style,
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridCity">
              <Form.Label>City</Form.Label>
              <Form.Control
                placeholder="required"
                name="city"
                value={this.state.city}
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridState">
              <Form.Label>Province</Form.Label>
              <Form.Control
                placeholder="required"
                name="province"
                value={this.state.province}
                onChange={this.handleInputChange}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridZip">
              <Form.Label>Postal Code</Form.Label>
              <Form.Control
                placeholder="required"
                value={this.state.postal_code}
                name="postal_code"
                onChange={this.handleInputChange}
              />
            </Form.Group>
          </Form.Row>
          <Accordion>
            <Card>
              <Accordion.Toggle as={Button} variant="outline-info" eventKey="0">
                Input Store Hours (required)
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form.Row>
                    {week.map((day, i) => (
                      <Form.Group key={week[i]} as={Col}>
                        <Form.Label>{week[i]}</Form.Label>
                        <Form.Control
                          id={`open${i}`}
                          name="Open"
                          onChange={this.updateHours(i)}
                          as="select"
                        >
                          <option value="">`Opening`</option>
                          <option value="24">Closed</option>
                          {this.createOpenOptions()}
                        </Form.Control>
                        <Form.Control
                          id={`close${i}`}
                          name="Close"
                          value={this.state.store_hours[i].Close}
                          onChange={this.updateHours(i)}
                          as="select"
                        >
                          <option value="">`Closing`</option>
                          <option value="0">Closed</option>
                          {this.createCloseOptions()}
                        </Form.Control>
                      </Form.Group>
                    ))}
                  </Form.Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Accordion.Toggle as={Button} variant="outline-info" eventKey="1">
                Subscribe to Email and Text Alerts
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <Form.Row>
                    <Col sm="3">
                      <Form.Group>
                        <Form.Check
                          label="Receive SMS Updates"
                          name="text_alerts_on"
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="9">
                      {this.state.text_alerts_on && (
                        <Form.Group
                          as={Form.Row}
                          controlId="formPlainAlertPhone"
                        >
                          <Form.Label column>
                            Phone Number to Receive SMS Updates
                          </Form.Label>
                          <Col>
                            <Form.Control
                              name="text_alerts_phone_number"
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Form.Group>
                      )}
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col sm="3">
                      <Form.Group>
                        <Form.Check
                          label="Receive Email Updates About Orders Within Mile1 Zone"
                          name="inzone_order_alert"
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="9">
                      {this.state.inzone_order_alert && (
                        <Form.Group
                          as={Form.Row}
                          controlId="inzone_order_alert_email1"
                        >
                          <Form.Label column>
                            Email to Receive Inzone Order Updates
                          </Form.Label>
                          <Col>
                            <Form.Control
                              name="inzone_order_alert_email1"
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Form.Group>
                      )}
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col sm="3">
                      <Form.Group>
                        <Form.Check
                          label="Receive Updates About Deliveries Booked With Mile1"
                          name="delivery_booked_alert"
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="9">
                      {this.state.delivery_booked_alert && (
                        <Form.Group
                          as={Form.Row}
                          controlId="delivery_booked_email"
                        >
                          <Form.Label column>
                            Email to Receive Delivery Booked Updates
                          </Form.Label>
                          <Col>
                            <Form.Control
                              name="delivery_booked_email"
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Form.Group>
                      )}
                    </Col>
                  </Form.Row>
                  <Form.Row>
                    <Col sm="3">
                      <Form.Group>
                        <Form.Check
                          label="Receive Updates About Completed Deliveries ?"
                          name="delivery_alerts"
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="9">
                      {this.state.delivery_alerts && (
                        <Form.Group
                          as={Form.Row}
                          controlId="delivery_alert_email"
                        >
                          <Form.Label column>
                            Email to Receive Delivery Updates
                          </Form.Label>
                          <Col>
                            <Form.Control
                              name="delivery_alert_email"
                              onChange={this.handleInputChange}
                            />
                          </Col>
                        </Form.Group>
                      )}
                    </Col>
                  </Form.Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {isLoggedIn && (
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-info"
                  eventKey="2"
                >
                  Price List
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainMerchantPrice">
                        <Form.Label>Merchant Price </Form.Label>
                        <Form.Control
                          value={this.state.merchant_price}
                          onChange={this.handleInputChange}
                          name="merchant_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainAddSTDPrice">
                        <Form.Label>Add STD Item Price</Form.Label>
                        <Form.Control
                          value={this.state.additional_standard_item_price}
                          onChange={this.handleInputChange}
                          name="additional_standard_item_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainWeightThreshold">
                        <Form.Label>Weight Threshold</Form.Label>
                        <Form.Control
                          value={this.state.weight_threshold}
                          onChange={this.handleInputChange}
                          name="weight_threshold"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainOverweightPrice">
                        <Form.Label>Overweight Price</Form.Label>
                        <Form.Control
                          value={this.state.overweight_order_price}
                          onChange={this.handleInputChange}
                          name="overweight_order_price"
                        />
                      </Form.Group>{" "}
                      <Form.Group as={Col} controlId="formPlainAddOWPrice">
                        <Form.Label>Add OW Item Price </Form.Label>
                        <Form.Control
                          value={this.state.additional_overweight_item_price}
                          onChange={this.handleInputChange}
                          name="additional_overweight_item_price"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainShipThreshold">
                        <Form.Label>Free Shipping Threshold</Form.Label>
                        <Form.Control
                          value={this.state.free_shipping_threshold}
                          onChange={this.handleInputChange}
                          name="free_shipping_threshold"
                        />
                      </Form.Group>{" "}
                      <Form.Group as={Col} controlId="formPlainShipCostNotfree">
                        <Form.Label>Shipping Cost If Not Free </Form.Label>
                        <Form.Control
                          value={this.state.shipping_cost_if_not_free}
                          onChange={this.handleInputChange}
                          name="shipping_cost_if_not_free"
                        />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )}
            {isLoggedIn && (
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-info"
                  eventKey="3"
                >
                  Delivery Details
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="3">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainDeliveryTitle">
                        <Form.Label>Delivery Title</Form.Label>
                        <Form.Control
                          onChange={this.handleInputChange}
                          name="delivery_title"
                        />
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        controlId="formPlainDeliveryDescription"
                      >
                        <Form.Label>Delivery Description</Form.Label>
                        <Form.Control
                          onChange={this.handleInputChange}
                          name="delivery_description"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainPickupNotes">
                        <Form.Label>Pick Up Notes</Form.Label>
                        <Form.Control
                          onChange={this.handleInputChange}
                          name="pick_up_notes"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainAllowedFsas">
                        <Form.Label>Allowed FSAs</Form.Label>
                        <Form.Control
                          value={this.state.allowed_fsas}
                          onChange={this.handleInputChange}
                          name="allowed_fsas"
                        />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )}
            {isLoggedIn && (
              <Card>
                <Accordion.Toggle
                  as={Button}
                  variant="outline-info"
                  eventKey="4"
                >
                  Billing Details
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="4">
                  <Card.Body>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainBillingContact">
                        <Form.Label>Billing Contact</Form.Label>
                        <Form.Control
                          onChange={this.handleInputChange}
                          name="billing_contact"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainBillingEmail">
                        <Form.Label>Billing Email</Form.Label>
                        <Form.Control
                          onChange={this.handleInputChange}
                          name="billing_email"
                        />
                      </Form.Group>
                    </Form.Row>
                    <Form.Row>
                      <Form.Group as={Col} controlId="formPlainPaymentTerms">
                        <Form.Label>Payment Terms</Form.Label>
                        <Form.Control
                          value={this.state.payment_terms}
                          onChange={this.handleInputChange}
                          name="payment_terms"
                        />
                      </Form.Group>
                      <Form.Group as={Col} controlId="formPlainPaymentDays">
                        <Form.Label>Payment Days</Form.Label>
                        <Form.Control
                          value={this.state.payment_days}
                          onChange={this.handleInputChange}
                          name="payment_days"
                        />
                      </Form.Group>
                    </Form.Row>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            )}
          </Accordion>
          {this.state.errors.length > 0 && (
            <Alert variant={"danger"}>
              <h3>Error</h3>
              {this.displayErrors(this.state.errors)}
            </Alert>
          )}
          <ButtonGroup className="btn-flat">
            <Button className="btn-flat" variant="outline-dark" type="submit">
              Create Merchant Account
            </Button>
          </ButtonGroup>
        </Form>
        <Link to="/stats">
          {isLoggedIn && (
            <Button variant="outline-info">Back to Stakeholders</Button>
          )}
        </Link>
      </div>
    );
  }
}
const mapStateToProps = ({ user }) => ({
  user: user,
});
const mapDispatchToProps = (dispatch) => ({
  postMerchant: (merchant) => dispatch(postMerchant(merchant)),
});
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateMerchantProfile)
);
